import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FAQS } from './data';

export default function FaqSection() {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-28 bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:sticky lg:top-28 lg:col-span-4 lg:self-start">
            <h2 className="font-heading text-3xl font-bold leading-tight tracking-[-0.02em] text-foreground-950 md:text-4xl">
              Tudo que você precisa saber
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600">
              Ficou com alguma dúvida? Nossa equipe responde em até um dia útil e ajuda a montar a campanha ideal para o seu time.
            </p>
            <button
              type="button"
              onClick={() => navigate('/solicitar-demo')}
              className="mt-7 inline-flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              Fale conosco
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="lg:col-span-8">
            <div className="rounded-3xl border border-background-200 bg-background-100 p-3">
              {FAQS.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.question} className="mb-2 overflow-hidden rounded-2xl bg-background-50 last:mb-0">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-6 p-5 text-left md:p-6"
                    >
                      <span className="font-heading text-base font-medium text-foreground-950 md:text-lg">{faq.question}</span>
                      <span
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors ${
                          isOpen ? 'border-primary-500 bg-primary-500 text-white' : 'border-background-300 text-foreground-700'
                        }`}
                      >
                        <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-6 md:px-6">
                        <p className="max-w-2xl text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}